// hero CTA·스크롤 인디케이터가 이동하는 페이지 내 스크롤 타깃 (page.tsx의 id="solution")
export const HERO_SCROLL_TARGET = '#solution';

// 타이핑 타이밍 — hero-typing-title(실제 타이핑)과 hero.tsx(딜레이 파생 계산)의 단일 근거.
// 타이핑 총 소요 시간 목표(ms). 글자 수로 나눠 글자당 간격을 구하되 하한(70ms)을 둔다.
export const TYPING_DURATION_MS = 2600;
export const MIN_PER_CHAR_MS = 70;

// lines 기준 실제 타이핑 소요(ms). hero 인트로 딜레이는 모두 이 값에서 파생한다.
export function typingDurationMs(lines: string[]): number {
  const total = lines.reduce((sum, line) => sum + line.length, 0);
  const perCharMs = Math.max(
    MIN_PER_CHAR_MS,
    Math.round(TYPING_DURATION_MS / Math.max(total, 1)),
  );
  return total * perCharMs;
}
